declare namespace $ {

	export class $shm_hitalama_map_table extends $mol_view {
		content( ): $mol_view
		controller( ): $mol_view
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=table.view.tree.d.ts.map